export default "__VITE_ASSET__d3e25348__"